export enum PercentageOrValue {
    Value = 1,
    Percentage = 2,
    All = 3,
    Options = 4
}